import React, { useEffect, useRef, useState } from "react";
import { primaryBlue, primaryGray } from "src/components/colors";
import axios from "axios";
import useStyles from "src/app/maintenance/assets/styles";
import Cookies from "js-cookie";
import Dragger from "antd/lib/upload/Dragger";
import { DragDrop } from "src/components/sub-components/DragAndDrop";
import { AddCommands } from "./AddCommands";
import { DropDownRMOTA } from "../step-3/components/DropDownRMOTA";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  DialogContent,
  DialogActions,
  Select,
  Chip,
  ListItemText,
  Dialog,
  DialogTitle,
  MenuItem
} from "@material-ui/core";
import { AddDeviceParameterConfiguration } from "./AddDeviceParameterConfiguration";
import { BootstrapInput } from "../../product-types/add-new-firmware/steps/Step1";
import { AddIconLarge, CloseIconColor, CloseIcon, DownArrow, QuestionIcon, UpArrow, UploadFile, Pointer } from "src/components/Icons";
import { environment } from "src/environments/environment";
import { createParameter, editParameter } from "src/app/auto-ml/utils/api";
import { ConfirmPopup } from "src/components/sub-components/ConfirmPopup";
import { Close } from "@material-ui/icons";
import AddVersionBinFile from "./AddVersionBinFile";


function Step2RemoteOTAConfig(
  {
    otaUpgradable, remotelyConfigurable,
    dataFormat, setDataFormat,
    errors, setErrors, setParameters, setRemotelyConfigurable,
    parameters, parameterError, setParameterError
    , classes, showFeatureUnavailablePopup, hasPackagePermission,
    setToaster, setErrorMessage, setReqSuccess,
    setLoading, setOpenOTA, setShowNotAvailablePopup, showNotAvailablePopup,
    setBinFile, productVersion, setProductVersion,
    setFlowChart, flowChartName, setFlowChartName,
    flowchartFileList, setFlowchartFileList,
    binError, setBinError, versionError, setVersionError,
    flowChartError, setFlowChartError, flowChartNameError, setFlowChartNameError,
    rmAckTopic,setrmAckTopic,otaAckTopic,
    setotaAckTopic,otaRequestTopic,setotaRequestTopic,
    rmConfigTopic,setrmConfigTopic,parametersAddedError

  }
) {
  const style = useStyles();
  const dataFormatOptions = ["String", "Json"];
  const inputTypeOptions = ["Text", "JSON", "HTML"]
  const formatOptions = ["String", "Integer", "Double", "Float", "Char"];
  const commandTypeOptions = ["Reset", "Restart", "Get_Config", "Other"]
  const [isInputTypeDropDown, setIsInputTypeDropDown] = useState(false);
  const [isFormatDropDown, setIsFormatDropDown] = useState(false);
  const [isCommandTypeDropdown, setIsCommandTypeDropdown] = useState(false);
  const [isDataFormatDropDown, setIsDataFormatDropDown] = useState(false);
  const [networkVisibility, setNetworkVisibility] = useState(false);
  const [topicVisibility, setTopicVisibility] = useState(false);
  const [messageVisibility, setMessageVisibility] = useState(false);
  const [idError, setIdError] = useState({ error: false, errorMsg: "" });
  const [labelError, setLabelError] = useState({ error: false, errorMsg: "" })
  const [formatError, setFormatError] = useState({ error: false, errorMsg: "" })
  const [inputTypeError, setInputTypeError] = useState({ error: false, errorMsg: "" });
  const [defaultValueError, setDefaultValueError] = useState({ error: false, errorMsg: "" })
  const [commandTypeError, setCommandTypeError] = useState({ error: false, errorMsg: "" });
  const [open, setOpen] = useState(false);

  const [openEditParamLabel, setOpenParamLabel] = useState(false);
  const [index, setIndex] = useState(-1);

  //parameter options from backend
  const [allParameters, setAllParameters] = useState([]);
  const [parameterToCreate, setParameterToCreate] = useState(true);
  const [selectOption, setSelectOption] = useState({
    label: "",
    format: "",
    inputType: "",
    parameter: "",
    parameterId: ""
  }
  );
  const [parameterTemplateToEdit, setParameterTemplateToEdit] = useState({
    label: ""
  });
  const [parameterTemplateEdit, setParameterTemplateEdit] = useState(false);
  //parameter inputs
  const [parameter, setParameter] = useState("");
  const [id, setId] = useState("");
  const [inputType, setInputType] = useState("");
  const [defaultVal, setDefaultVal] = useState("");
  const [format, setFormat] = useState("");
  const [join, setJoin] = useState([]);
  const [commandType, setCommandType] = useState("");
  const [label, setLabel] = useState("");

  const [addParameter, setAddParameter] = useState(false);
  const [addCommand, setAddCommand] = useState(false);
  const [tab, setTab] = useState("parameter");

  const [mainType, setMainType] = useState(""); // network , topic or message
  const [type, setType] = useState("");

  useEffect(() => {
    function handleClickOutside(event) {
      if (isDataFormatDropDown) {
        if (
          !event.target.closest('.dataformat-dropdown')
        ) {
          setIsDataFormatDropDown(false);
        }
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isDataFormatDropDown]);
  const addParameterCancel = () => {
    setOpen(false);
    setParameters([]);
    setRemotelyConfigurable(true);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
  }

  const addParameterDone = () => {
    setType("");
    setOpen(false);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
  };

  const openNetworkVisibility = () => {
    setNetworkVisibility(!networkVisibility);
  };
  const openTopicVisibility = () => {
    setTopicVisibility(!topicVisibility);
  };
  const openMessageVisibility = () => {
    setMessageVisibility(!messageVisibility);
  };
  const handleInputTypeChange = (option) => {
    setInputType(option);
    setInputTypeError({ error: false, errorMsg: "" });
  }
  const handleDataFormatChange = (option) => {
    setDataFormat(option);
    setErrors(prevErrors => ({
      ...prevErrors,
      dataFormatError: null
    }));
    setIsDataFormatDropDown(false);
  };

  const handleFormatChange = (option) => {
    setFormat(option);
    setFormatError({ error: false, errorMsg: "" });
  };
  const handleFormatSelect = (value) => {
    setFormat(value);
    setFormatError({ error: false, errorMsg: "" });
  }
  const handleInputTypeSelect = (value) => {
    setInputType(value);
    setInputTypeError({ error: false, errorMsg: "" });
  }
  const validateDefaultValueFormat = (format, defaultValue) => {
    let valid = true;
    format = format.toLowerCase();
    switch (format) {
      case "string":
        if (isNumeric(defaultValue)) {
          valid = false;
          setDefaultValueError({ error: true, errorMsg: "The input cannot be 'integer' only." })
        }
        break
      case "char":
        if (!isCharValid(defaultValue)) {
          valid = false;
          setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
        }
        break;
      case "double":
      case "float":
        if (!isNumeric(defaultValue)) {
          valid = false; // Must be numeric
          setDefaultValueError({ error: true, errorMsg: "The input must be a numeric value" })
        }
        break;
      case "integer":
        if (!isStrictInteger(defaultValue)) {
          valid = false; // Must be a valid integer
          setDefaultValueError({ error: true, errorMsg: "The input must be an integer" })
        }
        break;
      default:
        break;
    }

    return valid;
  }
  function isStrictInteger(value) {
    if (isNaN(value)) {
      return false; // Return false for invalid numbers
    }
    const num = parseFloat(value);
    return Number.isInteger(num) && value.indexOf('.') === -1;
  }
  const handleSwitchTab = (tabSelected) => {
    setTab(tabSelected)
  }
  function isNumeric(value) {
    return !isNaN(value) && !isNaN(parseFloat(value));
  }
  function isCharValid(value) {
    return /^.$/.test(value); // any single character
    // return /^[a-zA-Z]$/.test(value);  //any single alphabet
  }




  const handleCloseParamLabelEdit = () => {
    setOpenParamLabel(false);
  }
  const handleConfirmEditParamLabel = async () => {
    setLoading(true);
    try {
      const response = await editParameter(parameterTemplateToEdit.label, parameterTemplateToEdit);
      if (response.status && response.status === 200) {
        setReqSuccess(true);
        setErrorMessage("Parameter label sucessfully updated");
        setToaster(true);
        setParameterTemplateEdit(true);
        setOpenParamLabel(false);

      } else {
        setReqSuccess(false);
        setErrorMessage("Error editing Parameter label");
        setParameterToCreate(false);
        setToaster(true);

        return;
      }

    } catch (err) {
      console.log("error catched", err)
      setReqSuccess(false);
      setParameterToCreate(false);
      setErrorMessage("Error editing Parameter label");
      setToaster(true);
      return;

    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }

  }

  const getParameterOptions = async () => {
    try {
      const response = await axios.get(`${environment.host}/core/remoteParameter`);
      const content = response.data && response.data.content ? response.data.content : [];
      setAllParameters(content);
      return content;
    } catch (error) {
      console.error('Failed to fetch parameter options:', error);
      return [];
    }
  };
  const handleParameterSelect = (value) => {
    setSelectOption(value);
    setParameter(value.parameter);
    setInputType(value.inputType);
    setFormat(value.format);
    setLabel(value.label)
    setId(value.parameterId);
    setParameterToCreate(false);
    setParameterError({ error: false, errorMsg: "" })
    setIdError({ error: false, errorMsg: "" })
    setLabelError({ error: false, errorMsg: "" })
    setInputTypeError({ error: false, errorMsg: "" })
    setFormatError({ error: false, errorMsg: "" })
    setDefaultValueError({ error: false, errorMsg: "" })

  }

  const handleCommandTypeSelect = (value) => {
    setCommandType(value);
    setCommandTypeError({
      error: false,
      errorMsg: ""
    })
  }
  const handleParameterCreate = (parameter, isCreate) => {
    setParameter(parameter);
    setParameterToCreate(isCreate);
  }


  const readParameters = async (values) => {
    if (type === "add-new") {
      let error;
      if (values.parameter === "" || values.parameterId === "" || values.inputType === "" || values.defaultValue === "" || values.format === "" || (values.isCommand && values.commandType == "")) {
        error = true;
        if (values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: addCommand ? "Command name is required" : "Parameter Name is required",
          });
        }
        if (values.label === "") {
          setLabelError({ error: true, errorMsg: "Label is required" });
        }
        if (values.parameterId === "") {
          setIdError({ error: true, errorMsg: "Id is required" });
        }
        if (values.defaultValue === "") {
          setDefaultValueError({ error: true, errorMsg: addCommand ? "Command value is required" : "Default value is required" });
        }
        if (values.inputType === "") {
          setInputTypeError({ error: true, errorMsg: "Input type is required" });
        }
        if (values.format === "") {
          setFormatError({ error: true, errorMsg: "Format is required" });
        }
        if (values.isCommand && values.commandType == "") {
          setCommandTypeError({ error: true, errorMsg: "Command type is required" })
        }
        if (error === true) {
          return;
        }
      }
      let formatMatchErrorCheck = validateDefaultValueFormat(values.format, values.defaultValue);
      if (!formatMatchErrorCheck) {
        return;
      };

      if (parameters.filter((obj) => obj.parameterId === values.parameterId).length > 0) {
        setIdError({ error: true, errorMsg: "parameter Id Already exist" });
        return;
      }
      //save as decimal if it is entered as integer.
      if ((values.format.toLowerCase() === "float" || values.format.toLowerCase() === "double") && isStrictInteger(values.defaultValue)) {
        const floatValue = parseFloat(values.defaultValue);
        const formatedFloatValue = floatValue.toFixed(1); // Ensure one decimal place 
        values.defaultValue = formatedFloatValue;
      }
      if (addParameter && parameterToCreate) {
        let parameterCreate = {
          label: label,
          format: format,
          inputType: inputType,
          parameter: parameter,
          parameterId: id
        }
        try {
          setLoading(true);
          const response = await createParameter(parameterCreate);
          if (response.status && response.status === 200) {
            setReqSuccess(true);
            setErrorMessage("Parameter label sucessfully added");
            setToaster(true);
          } else {
            setReqSuccess(false);
            setErrorMessage("Error adding Parameter label");
            setToaster(true);
            return;
          }

        } catch (err) {
          console.log("error catched", error)
          setReqSuccess(false);
          setErrorMessage("Error adding Parameter label");
          setToaster(true);
          return;

        } finally {
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        }
      }


      setDefaultValueError({ error: false, errorMsg: "" });
      setParameters((current) => [...current, values]);
    }
    if (type === "edit" && index !== -1) {
      const keys = Object.keys(values);
      let error;
      if (values.parameter === "" || values.parameterId === "" || values.inputType === "" || values.defaultValue === "" || values.format === "" || (values.isCommand && values.commandType == "")) {
        error = true;
        if (values.parameter === "") {
          setParameterError({
            error: true,
            errorMsg: "Parameter Name is required",
          });
        }
        if (values.defaultValue === "") {
          setDefaultValueError({ error: true, errorMsg: "Default value is required" });
        }
        if (values.inputType === "") {
          setInputTypeError({ error: true, errorMsg: "Input type is required" });
        }
        if (values.format === "") {
          setFormatError({ error: true, errorMsg: "Format is required" });
        }
        if (values.parameterId === "") {
          setIdError({ error: true, errorMsg: "Parameter Id is required" });
        }
        if (values.isCommand && values.commandType == "") {
          setCommandTypeError({ error: true, errorMsg: "Command type is required" })
        }
        if (error == true) {
          return;
        }

      }
      let formatMatchErrorCheck = validateDefaultValueFormat(values["format"], values["defaultValue"]);
      if (!formatMatchErrorCheck) { return; }
      if ((values.format.toLowerCase() === "float" || values.format.toLowerCase() === "double") && isStrictInteger(values.defaultValue)) {
        const floatValue = parseFloat(values.defaultValue);
        const formatedFloatValue = floatValue.toFixed(1); // Ensure one decimal place 
        values.defaultValue = formatedFloatValue;
      }
      keys.map((k) => {
        if (values[k] !== "") {
          parameters[index][k] = values[k];
        }
      });
      const paramTemplates = await getParameterOptions();
      const paramTemplateCurrent = paramTemplates.find(p => p.label === label);
      let isEdittedLabel = false;
      if (paramTemplateCurrent) {
        isEdittedLabel = paramTemplateCurrent.parameterId != id || paramTemplateCurrent.format != format || paramTemplateCurrent.inputType != inputType || paramTemplateCurrent.parameter != parameter
      }
      if (addParameter && isEdittedLabel) {
        let parameterEdit = {
          label: label,
          format: format,
          inputType: inputType,
          parameter: parameter,
          parameterId: id
        }
        setParameterTemplateToEdit(parameterEdit);
        setParameterTemplateEdit(true)
        setOpenParamLabel(true);
        if (!parameterTemplateEdit) {
          return;
        }
      }
      setDefaultValueError({ error: false, errorMsg: "" });
      setParameters(parameters);
      setType("");
    }
    setParameter("");
    setId("");
    setInputType("");
    setDefaultVal("");
    setFormat("");
    setLabel("");

    setJoin([]);
    if (addParameter) {
      setAddParameter(false);
    }
    if (addCommand) {
      setAddCommand(false);
      setCommandType("");
    }
    setErrors({ ...errors, parametersError: null });
  };


  const deleteParameter = (index) => {
    let parameterIdToDelete = parameters[index].parameterId;
    let updatedParams = parameters;
    parameters.forEach(parameter => {
      if (parameter.parameterId !== parameterIdToDelete && parameter.joinParameter && parameter.joinParameter.includes(parameterIdToDelete)) {
        const updatedJoinParameter = parameter.joinParameter.filter(i => i != parameterIdToDelete)
        updatedParams = updatedParams.map(p => p.parameterId == parameter.parameterId ? { ...p, joinParameter: updatedJoinParameter } : p);
      }
    })
    const updatedParamList = updatedParams.filter(p => p.parameterId !== parameters[index].parameterId);
    setParameters(updatedParamList);
    if (!parameters || updatedParamList.length === 0) {
      setErrors({ ...errors, parametersError: "Remote Config Parameters are Required" });
    }
  };

  const openAddParameter = async (mainType, type, i) => {
    // fetch latest parameter options (getParameterOptions returns array)
    setLoading(true);
    try {
      const parametersOptions = await getParameterOptions();
      const parametersOptionsFiltered = parametersOptions.filter(
        (param) => !parameters.some((p) => p.label === param.label)
      );
      setAllParameters(parametersOptionsFiltered);
    }
    catch (error) {
      setToaster(true);
      setReqSuccess(false);
      setErrorMessage(error.message);
      setLoading(false)
      return;
    }
    finally {
      setLoading(false)
    }

    setMainType(mainType);
    setType(type);
    setIndex(i);
    if (type === "edit") {
      setInputType(parameters[i].inputType);
      setFormat(parameters[i].format);
      setJoin(parameters[i].joinParameter);
      setDefaultVal(parameters[i].defaultValue);
      setId(parameters[i].parameterId);
      setParameter(parameters[i].parameter);
      setLabel(parameters[i].label)
    }
    setAddParameter(true);
  };

  const openAddCommand = (type, i) => {
    setType(type);
    setIndex(i);
    setMainType("")


    if (type === "edit") {
      setInputType(parameters[i].inputType);
      setFormat(parameters[i].format);
      setDefaultVal(parameters[i].defaultValue);
      setId(parameters[i].parameterId);
      setParameter(parameters[i].parameter);
      setCommandType(parameters[i].commandType)
    }
    setAddCommand(true);
  };

  const closeAddParameter = () => {
    setType("");
    setAddParameter(false);
    setAddCommand(false);
    setParameter("");
    setId("");
    setInputType("");
    setDefaultVal("");
    setCommandType("");
    setLabel("");
    setFormat("");
    setCommandType('')
    setJoin([]);
    setParameterError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" });
    setDefaultValueError({ error: false, errorMsg: "" });
    setLabelError({ error: false, errorMsg: "" });
    setInputTypeError({ error: false, errorMsg: "" });
    setFormatError({ error: false, errorMsg: "" });
    setCommandTypeError({ error: false, errorMsg: "" })
  };

  const selectJoin = (e) => {
    setJoin(e.target.value);
  };

  const removeJoin = (value) => {
    setJoin(join.filter((d) => d !== value));
  };
  const renderTabContent = () => {
    if (remotelyConfigurable) return null;

    if (tab === "command") {
      return (
        <AddCommands
          open={(type, i) => openAddCommand(type, i)}
          parameters={parameters}
          readParameters={readParameters}
          parametersAddedError={parametersAddedError}
          deleteParameter={deleteParameter}
          isEditDelete={true}
        />
      );
    }

    return (
      <AddDeviceParameterConfiguration
        openNetworkVisibility={openNetworkVisibility}
        openTopicVisibility={openTopicVisibility}
        openMessageVisibility={openMessageVisibility}
        networkVisibility={networkVisibility}
        topicVisibility={topicVisibility}
        messageVisibility={messageVisibility}
        open={(mainType, type, i) => openAddParameter(mainType, type, i)}
        parameters={parameters}
        readParameters={readParameters}
        parametersAddedError={parametersAddedError}
        deleteParameter={deleteParameter}
      />
    );
  };

  return (
    <>

      {(!remotelyConfigurable) &&
        <Grid container alignItems="center" justifyContent="center" spacing={1} style={{ marginBottom: "20px" }}>
          <Grid item xs={6} md={6}
            className={classes.gridStyle}
          >
            <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
              Remote Config Topic:
            </Typography>

            <FormControl className={style.input}>
              <input
                className={style.formInputNew}
                disabled={type === "view"}
                onChange={(e) => {
                  setrmConfigTopic(e.target.value);
                }}
                value={
                  rmConfigTopic
                }
              />
            </FormControl>
            {errors.rmConfigError && errors.rmConfigError.length > 0 && (
              <Typography className={style.errorText}>
                {errors.rmConfigError}</Typography>
            )}
          </Grid>
          <Grid item xs={6} md={6}
            className={classes.gridStyle}
          >
            <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
              Remote Config Ack Topic:
            </Typography>
            <FormControl className={style.input}>
              <input
                className={style.formInputNew}
                disabled={type === "view"}
                onChange={(e) => {
                  setrmAckTopic(e.target.value);
                }}
                value={
                  rmAckTopic
                }
              />
            </FormControl>
            {errors.rmAckError && errors.rmAckError.length > 0 && (
              <Typography className={style.errorText}>
                {errors.rmAckError}</Typography>
            )}
          </Grid>
        </Grid>}
      {(!otaUpgradable) &&
        <Grid container alignItems="center" justifyContent="center" spacing={1} style={{ marginBottom: "20px" }}>
          <Grid item xs={6} md={6}
            className={classes.gridStyle}
          >
            <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
              OTA Config Topic:
            </Typography>
            <FormControl className={style.input}>
              <input
                className={style.formInputNew}
                onChange={(e) => {
                  setotaRequestTopic(e.target.value);
                }}
                value={
                  otaRequestTopic
                }
              />
            </FormControl>
            {errors.otaError && errors.otaError.length > 0 && (
              <Typography className={style.errorText}>
                {errors.otaError}</Typography>
            )}
          </Grid>
          <Grid item xs={6} md={6}
            className={classes.gridStyle}
          >
            <Typography className={`${classes.labelStyle} ${type === "view" ? classes.greyLabel : ''}`}>
              OTA Config Ack Topic:
            </Typography>

            <FormControl className={style.input}>
              <input
                className={style.formInputNew}
                disabled={type === "view"}
                onChange={(e) => {
                  setotaAckTopic(e.target.value);
                }}
                value={
                  otaAckTopic
                }
              />
            </FormControl>
            {errors.otaAckError && errors.otaAckError.length > 0 && (
              <Typography className={style.errorText}>
                {errors.otaAckError}</Typography>
            )}
          </Grid>
        </Grid>}
      {/** Data format */}
      <Grid container style={{ marginBottom: "20px" }}>
        <Grid item xs={12} md={12}>

          <Typography className={style.typo}>
            Data Format
            <span className={style.required}>*</span>
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <FormControl className={`dataformat-dropdown`} style={{ width: "100%" }} >
            <Grid container style={{ height: '44px' }}>
              <Grid container className={style.formInputNew}
                style={{ cursor: 'pointer', width: '100%' }}
                alignContent='center'
                onClick={() => setIsDataFormatDropDown(true)}
              >
                <Grid item style={{ flex: 1 }}>
                  <input
                    placeholder="Select Data Format"
                    style={{ border: 'none', width: '100%' }}
                    value={dataFormat}
                    onChange={(e) => handleDataFormatChange(e.target.value)}
                  />
                </Grid>
                <Grid item onClick={() => setIsDataFormatDropDown(!isDataFormatDropDown)}> {isDataFormatDropDown ? <UpArrow /> : <DownArrow />} </Grid>
              </Grid>
              {isDataFormatDropDown && (
                <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                  {dataFormatOptions.map((option, index) => {
                    return (
                      <Grid item className={style.option} key={index}
                        onClick={() => {
                          handleDataFormatChange(option)
                        }}
                      >
                        {option}
                      </Grid>
                    )
                  })
                  }
                </div>
              )}
            </Grid>
            {errors.dataFormatError && (
              <span className="form-error">
                {errors.dataFormatError}
              </span>
            )}
          </FormControl>
        </Grid>
      </Grid>

      {(!otaUpgradable || !remotelyConfigurable) &&

        <Grid container  style={{ marginBottom: "20px" }} >
          <Grid item xs={12} md={12}>
            <Typography className={style.typo}>
              Version number
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container alignItems="center"  >
              <Grid item xs={12} md={12}>
                <FormControl className={style.input}>
                  <input
                    className={style.formInputNew}
                    type="text"
                    placeholder="Enter Version Here"
                    value={productVersion}
                    onChange={(e) => {
                      setProductVersion(e.target.value);
                      setErrors({ ...errors, versionError: "" });
                    }}
                  />
                </FormControl>
                {errors.versionError && errors.versionError.length > 0 == true && (
                  <span className="form-error">
                    {errors.versionError}
                  </span>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>}

      {/* {remotelyConfigurable &&
      //   <Grid container>
      //     <Grid item xs={12} md={12}>
      //         {type === "view" ? "View" : type === "edit" ? "Edit" : "Add"}{" "}
      //         Parameter/Commands
      //     </Grid>
      //   </Grid>
      // */}

      <Grid container  style={{ alignItems: "center", margin: "0 0 20px 0", padding: "8px", background: "#FBFBFC", borderRadius: "4px", border: "1px solid #E2E5ED", gap: "16px" }} >
        {!otaUpgradable && <AddVersionBinFile
          setBinFile={setBinFile}
          binError={binError} setBinError={setBinError}
          setReqSuccess={setReqSuccess} setErrorMessage={setErrorMessage} setToaster={setToaster} />}
        {!remotelyConfigurable &&
          <Grid container style={{ alignItems: "center" }} >
            <Grid item xs={6} md={6}
              onClick={() => handleSwitchTab('parameter')}
              className={style.switchTab}
              style={{
                borderBottom: tab == "parameter" ? '3px solid #2A7CED' : '1px solid #ccc', padding: "5px"
              }}>
              <div>
                Parameters
                <span className={style.required}>*</span>
              </div>

            </Grid>
            <Grid item xs={6} md={6}
              onClick={() => handleSwitchTab('command')}
              className={style.switchTab}
              style={{
                borderBottom: tab == "command" ? '3px solid #2A7CED' : '1px solid #ccc', padding: "5px"
              }}>
              <div>
                Commands
                <span className={style.required}>*</span>
              </div>
            </Grid>

          </Grid>}
        {renderTabContent()}

      </Grid>


      {!remotelyConfigurable &&
        <Dialog open={addCommand || addParameter} maxWidth="md" fullWidth>
          <Grid container>
            <Grid item xs={10} md={10}>

              <DialogTitle>
                {type === "view" ? "View" : type === "edit" ? "Edit" : "Add"}{" "}
                {addParameter ? "Parameter" : addCommand ? "Command" : "Firmware"}
              </DialogTitle>

            </Grid>
            <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
              <IconButton
                onClick={() => {
                  addParameter ? closeAddParameter() : "";
                }}
              >
                <CloseIconColor />
              </IconButton>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: '#F9F9F9', width: '100%' }}>
            {tab == "parameter" && addParameter && (
              <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
                <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                  <Typography className={style.typo}>Parameter name<span className={style.required}>*</span> </Typography>
                  <FormControl className={style.input}>
                    <DropDownRMOTA
                      isSingle={true}
                      options={allParameters}
                      type="parameter"
                      placeholder="Select Parameter Name"
                      value={type === "view" ? parameters[index].name : parameter?parameter:""}
                      setSelectValue={v => setParameter(v.target.value)}
                      disabled={type === "view"}
                      onClick={handleParameterSelect}
                      handleParameterCreate={handleParameterCreate}
                    />


                  </FormControl>
                  {parameterError.error && (
                    <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
                </Grid>
                <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                  <Typography className={style.typo}>Parameter ID<span className={style.required}>*</span></Typography>
                  <FormControl className={style.input}>
                    <input
                      className={style.formInputNew}
                      disabled={type === "view"}
                      type="number"
                      value={id}
                      onChange={(e) => {
                        setId(e.target.value);
                        setIdError({ error: false, errorMsg: "" });
                      }}
                    />

                  </FormControl>
                  {idError.error && (
                    <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
                </Grid>
                <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                  <Typography className={style.typo}>Label<span className={style.required}>*</span></Typography>
                  <FormControl className={style.input}>
                    {type === "edit" ? (
                      <Tooltip title="Label cannot be edited once saved" arrow>
                        <input
                          disabled
                          className={style.formInputNew}
                          value={parameters[index].label}
                        />
                      </Tooltip>
                    ) : (
                      <input
                        className={style.formInputNew}
                        disabled={type === "add-new" ? false : true}
                        value={label}
                        onChange={(e) => {
                          setLabel(e.target.value);
                          setLabelError({ error: false, errorMsg: "" });
                        }}
                      />
                    )}
                  </FormControl>
                  {labelError.error && (
                    <Typography className={style.errorText}>{labelError.errorMsg}</Typography>)}
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={6}
                  style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}
                >
                  <Typography className={style.typo}>Input Type<span className={style.required}>*</span></Typography>
                  <FormControl className={classes.input}>
                    <DropDownRMOTA
                      isSingle={true}
                      options={inputTypeOptions}
                      type="commandType"
                      placeholder="Select Input Type"
                      value={type === "view" ? parameters[index].inputType : inputType?inputType:""}
                      setSelectValue={(e) => setInputType(e.target.value)}
                      disabled={!(parameterToCreate || type == "edit")}
                      onClick={handleInputTypeSelect}

                    />
                    <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>

                  </FormControl>
                </Grid>
                <Grid item xs={6} md={6} style={{
                  textAlign: "left", paddingBottom: "20px"
                }}>
                  <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                  <FormControl className={classes.input}>
                    <DropDownRMOTA
                      isSingle={true}
                      options={formatOptions}
                      type="commandType"
                      placeholder="Select Format Type"
                      value={type === "view" ? parameters[index].format : format?format:""}
                      setSelectValue={(e) => setFormat(e.target.value)}
                      disabled={!(parameterToCreate || type == "edit")}
                      onClick={handleFormatSelect}
                    />
                  </FormControl>
                  <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={6}
                  style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}
                >
                  <Typography className={style.label}>Default Value<span className={style.required}>*</span> &nbsp;
                    <Tooltip
                      arrow
                      title={
                        <React.Fragment>
                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <Typography
                                style={{ fontSize: "12px", color: '#FFFFFF', fontWeight: 300, fontFamily: 'poppins' }}
                              >{"Use curly braces {} to specify values that vary by device. For example, "}<br />
                                {"S2D/SA/VA/{deviceId}"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      }
                      interactive
                      placement="right"
                    >
                      <IconButton style={{ padding: "1px 2px 2px 0px" }}>
                        <QuestionIcon />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                  <FormControl className={style.input}>
                    <input
                      className={style.formInputNew}
                      disabled={type === "view" || format === ""}
                      onChange={(e) => {
                        setDefaultVal(e.target.value);
                        if (format == "Char" && e.target.value.length > 1) {
                          setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
                        }
                        else {
                          setDefaultValueError({ error: false, errorMsg: "" })
                        }
                      }}
                      value={
                        type === "view"
                          ? parameters[index].defaultValue
                          : defaultVal
                      }
                    />

                  </FormControl>
                  {defaultValueError.error && (
                    <Typography className={style.errorText}>
                      {defaultValueError.errorMsg}</Typography>
                  )}
                </Grid>

                <Grid item xs={12} md={12} style={{ textAlign: "left", paddingBottom: "20px" }}>
                  <Typography className={style.label}>Join Parameter</Typography>
                  <FormControl className={style.input}>
                    <Select
                      disabled={type === "view" ? true : false}
                      id="demo-customized-select-native"
                      value={
                        type === "view" ? parameters[index].joinParameter : join
                      }
                      className={style.input}
                      onChange={selectJoin}
                      multiple
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                      renderValue={(selected: string[]) => (
                        <div>
                          {selected.map((value, i) => (
                            <Chip
                              key={i}
                              label={value}
                              className={style.chip}
                              onMouseDown={(event) => {
                                event.stopPropagation();
                              }}
                              onDelete={() => removeJoin(value)}
                            />
                          ))}
                        </div>
                      )}
                      input={<BootstrapInput />}
                    >
                      {type === "add-new" ? (
                        parameters
                          .filter((obj) => obj.parameterCategory === mainType)
                          .map((p, j) => {
                            return (
                              <MenuItem value={p.parameterId} key={j}>
                                <ListItemText
                                  primary={p.parameterId}
                                  style={{ color: primaryGray }}
                                />
                              </MenuItem>
                            );
                          })
                      ) : type === "edit" ? (
                        parameters
                          .filter((obj) => obj.parameterCategory === mainType)
                          .filter((ob) => ob.parameterId !== parameters[index].parameterId)
                          .map((p, j) => {
                            return (
                              <MenuItem value={p.parameterId} key={j}>
                                <ListItemText
                                  primary={p.parameterId}
                                  style={{ color: primaryGray }}
                                />
                              </MenuItem>
                            );
                          })
                      ) : (
                        <div></div>
                      )}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            )}
            {addCommand && (
              <Grid container style={{ textAlign: "center", marginTop: "20px" }}>
                <Grid item xs={6} style={{ textAlign: "left", paddingBottom: "20px" }}>
                  <Typography className={style.typo}>Command name<span className={style.required}>*</span> </Typography>
                  {type === "edit" ? (

                    <input
                      disabled
                      className={style.formInputNew}
                      value={parameters[index].parameter}
                    />
                  ) :
                    <input
                      disabled={type === "add-new" ? false : true}
                      className={style.formInputNew}
                      onChange={(e) => {
                        setParameter(e.target.value)
                        setParameterError({ error: false, errorMsg: "" })
                      }}
                      value={parameter}
                    />
                  }
                  {parameterError.error && (
                    <Typography className={style.errorText}>{parameterError.errorMsg}</Typography>)}
                </Grid>
                <Grid item xs={6} md={6} style={{ textAlign: "left", paddingBottom: "20px", paddingLeft: "20px" }}>
                  <Typography className={style.typo}>Command ID<span className={style.required}>*</span></Typography>
                  <FormControl className={style.input}>
                    {type === "edit" ? (
                      <Tooltip title="Parameter ID cannot be edited once saved" arrow>
                        <input
                          disabled
                          className={style.formInputNew}
                          type="number"
                          value={parameters[index].parameterId}
                        />
                      </Tooltip>
                    ) : (
                      <input
                        className={style.formInputNew}
                        disabled={type === "add-new" ? false : true}
                        type="number"
                        value={id}
                        onChange={(e) => {
                          setId(e.target.value);
                          setIdError({ error: false, errorMsg: "" });
                        }}
                      />
                    )}
                  </FormControl>
                  {idError.error && (
                    <Typography className={style.errorText}>{idError.errorMsg}</Typography>)}
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={6}
                  style={{ textAlign: "left", paddingBottom: "20px" }}
                >
                  <Typography className={style.label}>Input Type<span className={style.required}>*</span></Typography>
                  <FormControl className={style.input}>
                    <Grid container >
                      <Grid container className={style.formInputNew}
                        style={{ cursor: 'pointer' }}
                        alignContent='center'
                        onClick={() => { setIsInputTypeDropDown(!isInputTypeDropDown) }}
                      >
                        <Grid item style={{ flex: 1 }}>
                          <input
                            disabled={type === "view"}
                            placeholder="Select Input Type"
                            className={classes.optionInput}
                            value={type === "view" ? parameters[index].inputType : inputType}
                            onChange={(e) => { setInputType(e.target.value); setInputTypeError({ error: false, errorMsg: "" }) }}
                          />
                        </Grid>
                        <Grid item> {isInputTypeDropDown ? <UpArrow /> : <DownArrow />} </Grid>
                      </Grid>
                      {isInputTypeDropDown && (
                        <div className={classes.dropdown} style={{ zIndex: 2000 }}>
                          {inputTypeOptions.map((option, index) => {
                            return (
                              <Grid item className={style.option} key={index}
                                onClick={() => {
                                  handleInputTypeChange(option)
                                  setIsInputTypeDropDown(!isInputTypeDropDown)
                                }}
                              >
                                {option}
                              </Grid>
                            )
                          })
                          }
                        </div>
                      )}
                      <Typography className={style.errorText}>{inputTypeError.errorMsg}</Typography>
                    </Grid>
                  </FormControl>
                </Grid>
                <Grid item xs={6} md={6} style={{
                  textAlign: "left", paddingBottom: "20px", paddingLeft: "20px"
                }}>
                  <Typography className={style.label}>Data format<span className={style.required}>*</span></Typography>
                  <DropDownRMOTA
                    isSingle={true}
                    options={formatOptions}
                    type="format"
                    placeholder="Select Data type"
                    value={type === "view" ? parameters[index].format : format?format:""}
                    setSelectValue={(e) => setFormat(e.target.value)}
                    disabled={type === "view"}
                    onClick={handleFormatChange} />
                  <Typography className={style.errorText}>{formatError.errorMsg}</Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={6}
                  style={{ textAlign: "left", paddingBottom: "20px" }}
                >
                  <Typography className={style.label}>Command Value<span className={style.required}>*</span> &nbsp;
                    <Tooltip
                      arrow
                      title={
                        <React.Fragment>
                          <Grid container>
                            <Grid item xs={12} md={12}>
                              <Typography
                                style={{ fontSize: "12px", color: '#FFFFFF', fontWeight: 300, fontFamily: 'poppins' }}
                              >{"Use curly braces {} to specify values that vary by device. For example, "}<br />
                                {"S2D/SA/VA/{deviceId}"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      }
                      interactive
                      placement="right"
                    >
                      <IconButton style={{ padding: "1px 2px 2px 0px" }}>
                        <QuestionIcon />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                  <FormControl className={style.input}>
                    <input
                      className={style.formInputNew}
                      disabled={type === "view" || format === ""}
                      onChange={(e) => {
                        setDefaultVal(e.target.value);
                        if (format == "Char" && e.target.value.length > 1) {
                          setDefaultValueError({ error: true, errorMsg: "Cannot add more than 1 character" })
                        }
                        else {
                          setDefaultValueError({ error: false, errorMsg: "" })
                        }
                      }}
                      value={
                        type === "view"
                          ? parameters[index].defaultValue
                          : defaultVal
                      }
                    />

                  </FormControl>
                  {defaultValueError.error && (
                    <Typography className={style.errorText}>
                      {defaultValueError.errorMsg}</Typography>
                  )}
                </Grid>
                <Grid item xs={6} md={6} style={{
                  textAlign: "left", paddingBottom: "20px", paddingLeft: "20px"
                }}>
                  <Typography className={style.label}>Command type<span className={style.required}>*</span></Typography>
                  <FormControl className={style.input}>
                    <Grid container >
                      <DropDownRMOTA
                        isSingle={true}
                        options={commandTypeOptions}
                        type="commandType"
                        placeholder="Select Command Type"
                        value={type === "view" ? parameters[index].commandType : commandType?commandType:""}
                        setSelectValue={(e) => setCommandType(e.target.value)}
                        disabled={type === "view"}
                        onClick={handleCommandTypeSelect}

                      />
                    </Grid>
                  </FormControl>
                  {commandTypeError.error && (
                    <Typography className={style.errorText}>{commandTypeError.errorMsg}</Typography>
                  )}
                </Grid>


              </Grid>

            )}



          </DialogContent>
          {((addParameter || addCommand) && type !== "view") && (
            <DialogActions style={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: '590px', paddingBottom: '20px' }}>
              <Button className={style.backButton} variant="contained" onClick={() => closeAddParameter()}>Cancel</Button>
              <Button className={style.saveButton}
                variant="contained"
                onClick={() => {
                  readParameters({
                    parameterCategory: mainType,
                    parameter,
                    parameterId: id,
                    inputType,
                    format,
                    label,
                    joinParameter: join,
                    defaultValue: defaultVal,
                    isCommand: addCommand ? true : false,
                    commandType: commandType
                  });
                }}
              >
                {type === "edit" ? "Update" : "Save"}
              </Button>
            </DialogActions>
          )}
          {((!addParameter && !addCommand) && type !== "view") && (
            <DialogActions style={{ display: 'flex', justifyContent: 'flex-end', paddingLeft: '590px', paddingBottom: '20px' }}>
              <Button className={style.backButton} variant="contained" onClick={addParameterCancel}>Cancel</Button>
              <Button className={style.saveButton}
                variant="contained"
                onClick={() => {
                  if (!hasPackagePermission("RemoteManager")) {
                    showFeatureUnavailablePopup('Remote Manager');
                  } else {
                    addParameterDone();
                  }
                }}
                disabled={parameters.length === 0}
              >
                Done
              </Button>
            </DialogActions>
          )}
        </Dialog>
      }

      <ConfirmPopup
        open={openEditParamLabel}
        closePopup={handleCloseParamLabelEdit}
        handleConfirm={handleConfirmEditParamLabel}
        handleDiscardConfirm={handleCloseParamLabelEdit}
        title={"Confirm update parameter template"}
        info={"Parameter template will also be editted with this action.Are you sure want to continue?"}
        type={"labelEdit"}
      />
      {showNotAvailablePopup && (
        <NotAvailablePopup
          open={showNotAvailablePopup.open}
          onClose={() => setShowNotAvailablePopup({ ...showNotAvailablePopup, open: false })}
          onCloseWithFeature={() => {
            setShowNotAvailablePopup({ ...showNotAvailablePopup, open: false });
            if (showNotAvailablePopup.featureName === 'Remote Manager') {
              addParameterDone();
            } else if (showNotAvailablePopup.featureName === 'OTA Manager') {
              setOpenOTA(false);
            }
          }}
          featureName={showNotAvailablePopup.featureName}
          onUpgrade={() => {
            setShowNotAvailablePopup({ ...showNotAvailablePopup, open: false });

            window.open(environment.azurepageLink);
          }}
        />
      )}
    </>)
};
export default Step2RemoteOTAConfig;
const NotAvailablePopup = ({ open, onClose, onCloseWithFeature, featureName, onUpgrade }) => {
  const style = useStyles()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          width: '512px',
          maxWidth: '512px',
        },
      }}
    >
      <DialogTitle>
        <Grid container justifyContent="flex-end" alignItems="center">
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" style={{ marginBottom: '15px' }}>
          You've just configured a feature available only in the Basic package. To perform {featureName} operations, please upgrade your plan.
        </Typography>
        <Grid container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              onClick={onUpgrade}
              className={style.buttonContained}
              style={{ backgroundColor: '#2A7CED', color: '#FFFFFF' }}
            >
              Upgrade Now
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              onClick={onCloseWithFeature}
              className={style.buttonOutlined}
            >
              OK
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

